import React, { useState } from "react";
import { FileText, Plus, Search } from "lucide-react";
import { reportApi } from "../../services/presentationApi";
import PresentationsList, { NewPresentationDialog } from "../Presentations/PresentationsList";

const FILTERS = [
  { value: "", label: "Tous" },
  { value: "project", label: "Projets" },
  { value: "client", label: "Clients" },
  { value: "programme", label: "Programmes" },
];

// Outils → Rapports : les rapports client faits dans Deepflow (A4, charte des présentations).
const ReportsPage = () => {
  const [query, setQuery] = useState("");
  const [scopeType, setScopeType] = useState("");
  const [archived, setArchived] = useState(false);
  const [creating, setCreating] = useState(false);
  return (
    <div className="mx-auto max-w-4xl space-y-5 py-6">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="space-y-1">
          <h1 className="flex items-center gap-2 text-2xl font-semibold text-slate-900">
            <FileText className="h-6 w-6 text-blue-600" /> Rapports
          </h1>
          <p className="text-sm text-slate-500">
            Rapports client en pages A4, à la charte des présentations, pour un projet, un client ou un programme. Le
            PDF est tenu à jour sur le Drive ; Nexus suit les consignes tirées de vos retours.
          </p>
        </div>
        <button type="button" onClick={() => setCreating(true)}
          className="inline-flex items-center gap-1.5 rounded-full bg-slate-900 px-4 py-2 text-sm font-semibold text-white hover:bg-slate-700">
          <Plus className="h-4 w-4" /> Nouveau rapport
        </button>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <div className="relative min-w-[14rem] flex-1">
          <Search className="pointer-events-none absolute left-2 top-2.5 h-4 w-4 text-slate-400" />
          <input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Titre, projet, client"
            className="w-full rounded-lg border border-slate-300 py-2 pl-8 pr-3 text-sm focus:border-blue-400 focus:outline-none" />
        </div>
        <div className="flex rounded-full border border-slate-200 bg-white p-0.5 text-sm">
          {FILTERS.map((item) => (
            <button key={item.value} type="button" onClick={() => setScopeType(item.value)}
              className={`rounded-full px-3 py-1 ${scopeType === item.value ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100"}`}>
              {item.label}
            </button>
          ))}
        </div>
        <label className="flex items-center gap-1.5 text-sm text-slate-600">
          <input type="checkbox" checked={archived} onChange={(event) => setArchived(event.target.checked)} /> Archivés
        </label>
      </div>
      <div className="rounded-xl border border-slate-200 bg-white p-3 shadow-sm">
        <PresentationsList api={reportApi} path="/tools/rapports" backLabel="Rapports"
          params={{ q: query, scope_type: scopeType, include_archived: archived || undefined, limit: 100 }}
          emptyText="Aucun rapport pour l'instant : « Nouveau rapport », ou demandez-en un à Nexus." />
      </div>
      {creating && <NewPresentationDialog api={reportApi} path="/tools/rapports" backLabel="Rapports" onClose={() => setCreating(false)} />}
    </div>
  );
};

export default ReportsPage;
